import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "questions-creation";

const keys = addTranslations(RESOURCE_NAME, {
    upload_file_modal_title: {
        en: "Create questions from Ditto template",
        fr: "Créer des questions à partir du template Ditto",
    },
    download_template_step_title: {
        en: "Step 1: Download the Template",
        fr: "Étape 1: Téléchargez le template",
    },
    download_template_step_description: {
        en: "Use our template to ensure your file meets the required format.",
        fr: "Utilisez notre template pour vous assurer que votre fichier respecte le format requis.",
    },
    download_template_button_label: {
        en: "Download Template",
        fr: "Télécharger le template",
    },
    fill_template_step_title: {
        en: "Step 2: Fill in your questions",
        fr: "Étape 2: Remplissez le template avec vos questions",
    },
    fill_template_step_description: {
        en: "Follow the column structure and examples in the template.",
        fr: "Suivez la structure des colonnes et les exemples dans le template.",
    },
    upload_file_step_title: {
        en: "Step 3: Upload your file",
        fr: "Étape 3: Uploadez votre fichier",
    },
    reminder_step_title: {
        en: "Reminder",
        fr: "Rappel",
    },
    reminder_step_description: {
        en: "Your file must be an Excel (.xlsx) and follow the template exactly. Incorrect formats will be rejected automatically.",
        fr: "Votre fichier doit être un Excel (.xlsx) et suivre le template exactement. Les formats incorrects seront rejetés automatiquement.",
    },
    uploaded_file_name: {
        en: "Uploaded file",
        fr: "Fichier téléchargé",
    },
    analyzing_file: {
        en: "Analyzing file...",
        fr: "Analyse du fichier...",
    },
    analyzing_file_description: {
        en: "This may take a few minutes.",
        fr: "Cela peut prendre quelques minutes.",
    },
    upload_file_modal_button_label: {
        en: "Import questions",
        fr: "Importer des questions",
    },
    upload_file_modal_placeholder: {
        en: "Upload a Ditto template",
        fr: "Téléverser un template Ditto",
    },
    close: {
        en: "Close",
        fr: "Fermer",
    },
    questions_created: {
        en: "{{count}} questions were successfully created",
        fr: "{{count}} questions ont été créées avec succès",
    },
    questions_error: {
        en: "We have encountered errors while creating the questions. Please try again.",
        fr: "Une erreur est survenue lors de la création des questions. Veuillez réessayer.",
    },
});
export function useCreateQuestionsFromUploadModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
